import React, { useMemo } from 'react'
import styled from 'styled-components'

import getNfcLocked from '../../lib/charge-point/getNfcLocked'
import getInstallationPhaseMode from '../../lib/charge-point/getInstallationPhaseMode'
import { ChargePoint, Connector } from '../../common/redux/api/web-api'
import useText from '../../common/hooks/useText'

import getIsHalo from './../../../src/lib/isHalo'

const SInfoItem = styled.span`
    margin-right: 3px;
`

type ConnectorInfoProps = {
    chargePoint: ChargePoint
    connector: Connector
    showDetailedInfo?: boolean
}

const ConnectorInfo = ({ chargePoint, connector, showDetailedInfo = true }: ConnectorInfoProps): React.ReactElement => {
    const text = useText()
    const downLight = chargePoint?.downLight
    const nfcLocked = getNfcLocked(chargePoint, connector)
    const isHalo = getIsHalo(chargePoint)

    const installationPhaseMode = useMemo(() => getInstallationPhaseMode(chargePoint), [chargePoint])
    const installationPhase = useMemo(() => connector?.installationPhase, [connector])
    const installationCurrent = useMemo(() => connector?.installationCurrent, [connector])

    return (
        <div data-testid={`connector-${connector?.connectorId}-info`}>
            {showDetailedInfo && (
                <>
                    {nfcLocked ? (
                        <SInfoItem className="fa fa-lock grayFont" title={text('msgRFIDLockEnabled')} />
                    ) : (
                        <SInfoItem className="fa fa-unlock grayFont" title={text('msgRFIDLockDisabled')} />
                    )}

                    {isHalo && downLight && (
                        <SInfoItem className="fa fa-lightbulb-o greenFont" title={text('msgDownlightEnabled')} />
                    )}
                    {isHalo && !downLight && (
                        <SInfoItem className="fa fa-lightbulb-o redFont" title={text('msgDownlightDisabled')} />
                    )}
                    {chargePoint?.additionalInfo?.partnerAccessible && (
                        <SInfoItem className="fa fa-bus darkBlueFont" title={text('msgPartnerAccessible')} />
                    )}
                </>
            )}

            {installationPhaseMode === '1P' && (
                <SInfoItem title={text('msgOnePhaseChargepoint')}>
                    1P ({installationPhase} - {installationCurrent} A)
                </SInfoItem>
            )}
            {installationPhaseMode === '3P' && (
                <SInfoItem title={text('msgThreePhaseChargepoint')}>3P ({installationCurrent} A)</SInfoItem>
            )}
        </div>
    )
}

export default ConnectorInfo
